export default "__VITE_ASSET__CNb2GwFQ__"